import $ from "jquery";

class LanguageSwitch {
  constructor() {

    this.mobileFormOrNot();
    this.mobileLangDropdownExists = false;
    this.events();
  }
  events() {
    // Close custom dropdown select when clicking outside it
    $(document).click(function (event) {
      var $target = $(event.target);
      if (
        !$target.closest("#lang-dropdown-wrapper-id").length &&
        $("#lang-dropdown__hidden-checkbox").is(":checked")
      ) {
        console.log("clicked ouside dropdown?");
        $("#lang-dropdown__hidden-checkbox").prop("checked", false); // Unchecks it
      }
    });

    this.showInputButton.on("click", this.showInput.bind(this));
    console.log('events');
  }
  // Methods

  // If it's mobile menu, display the search in different place
  // Also display the social isons in different place 
//   Temporary comment
  mobileFormOrNot() {
    var tablet = window.matchMedia("(max-width: 991px)");
    if (!this.mobileLangDropdownExists && tablet.matches) {
      this.mobileLangDropdownExists = true;
      $(".lang-dropdown").appendTo(".language-dropdown__mobile-wrapper");
    //   $(".main-nav__social-icons").appendTo(".navbar-collapse");
    }
  }

  showInput() {
    console.log('dada2');
    $('#menu-main-menu>li>a').toggleClass("max-1450:!pl-3");

    this.searchField.animate({ width: "toggle" });
    this.searchField.trigger("focus");
  }

}

export default LanguageSwitch;
